module.exports = __webpack_public_path__ + "static/media/new_wps_4.27d7e752.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/new_wps_4.jpg
// module id = 1904
// module chunks = 0